import React from 'react';
import { Dropdown } from 'antd';
import './menuStyles.css';
import { mapPlaces } from '../../tools/mapPlaces';
export const CustomMenu = ({ onMapClick }) => {
  const onClick = (e) => {
    onMapClick({
      target: {
        dataset: {
          id: e.key,
        },
      },
    });
  };

  return (
    <div className='menuContainer'>
      <Dropdown
        menu={{
          items: mapPlaces.map((place) => ({
            label: `${place.uzLang.title} / ${place.engLang.title}`,
            key: place.id,
            onClick,
          })),
        }}
        trigger={['click']}
      >
        <div className='dropDownBox'>
          <img className='dropDownImage' src={require('../../assets/menu.png')} alt='dropdown' />
        </div>
      </Dropdown>
    </div>
  );
};
